<template>
    <div>
        <div v-if="educationLevel" class="row">
            <span class="row-label">Уровень образования:</span>
            <span class="row-value">{{ getLowerCase(educationLevel.field_value) }}</span>
        </div>
        <div v-if="educationPlaceValue" class="row">
            <span class="row-label">Учебное заведение:</span>
            <span class="row-value">{{ educationPlaceValue }}</span>
        </div>
        <div v-if="item.city" class="row">
            <span class="row-label">Город:</span>
            <span class="row-value">{{ item.city.value }}</span>
        </div>
        <div v-if="period" class="row">
            <span class="row-label">Период обучения:</span>
            <span class="row-value">{{ period }}</span>
        </div>
        <div v-if="isHighEducation && item.faculty" class="row">
            <span class="row-label">Наименование факультета:</span>
            <span class="row-value">{{ getLowerCase(item.faculty) }}</span>
        </div>
        <div v-if="isHighEducation && educationForm" class="row">
            <span class="row-label">Форма обучения:</span>
            <span class="row-value">{{ getLowerCase(educationForm.field_value) }}</span>
        </div>
        <div v-if="isHighEducation && item.educationProgram" class="row">
            <span class="row-label">Наименование образовательной программы:</span>
            <span class="row-value">{{ getLowerCase(item.educationProgram) }}</span>
        </div>
        <div v-if="!showSchoolClass && ( specialty || item.specialtySpecial )" class="row">
            <span class="row-label">Специальность:</span>
            <span class="row-value">{{ getLowerCase(specialty.field_value || item.specialtySpecial) }}</span>
        </div>
        <div v-if="!showSchoolClass && item.qualification" class="row">
            <span class="row-label">Квалификация:</span>
            <span class="row-value">{{ getLowerCase(item.qualification) }}</span>
        </div>
        <div v-if="isHighEducation && okso" class="row">
            <span class="row-label">Код ОКСО:</span>
            <span class="row-value">{{ getLowerCase(okso.field_value) }}</span>
        </div>
        <div v-if="!showSchoolClass && academicDegreeValue" class="row">
            <span class="row-label">Ученая степень:</span>
            <span class="row-value">{{ academicDegreeValue }}</span>
        </div>
        <div v-if="showSchoolClass && item.schoolClass" class="row">
            <span class="row-label">Класс:</span>
            <span class="row-value">{{ item.schoolClass }}</span>
        </div>
    </div>
</template>

<script>
import { getFormattedDate } from "@/tools/moment-date";
import { mapGetters, mapActions } from "vuex";

const getters = ['dictionaryByType'];
const actions = ['getDictionaryItemById'];

export default {
    name: "ParticipantEducationBlock",

    props: {
        item: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            specialty: '',
            place: '',
            educationForm: '',
            okso: '',
        };
    },

    computed: {
        ...mapGetters(getters),

        educationLevel() {
            const levelList = this.dictionaryByType('education_level');
            return levelList && this.item ? levelList.find(el => String(el.id) === String(this.item.foreignLevelId)) : null;
        },

        showSchoolClass() {
            const enableOptions = ['base_general', 'middle_general'];
            return this.educationLevel && enableOptions.includes(this.educationLevel.field_name);
        },

        isHighEducation() {
            const enableOptions = [
                'hi_bachelor', 
                'hi_master',
                'hi_master_or_specialist',
                'hi_specialist',
                'hi_prof_cadr',
                'foreign',
                'add',
                'middle_profi',
                'profi',
            ];
            return this.educationLevel && enableOptions.includes(this.educationLevel.field_name);
        },

        specialStudyPlace() {
            const enableOptions = ['add', 'base_general', 'middle_general', 'foreign'];
            return this.educationLevel && enableOptions.includes(this.educationLevel.field_name);
        },

        period() {
            if (this.item && this.item.dateStart) {
                const start = this.item.dateStart ? getFormattedDate(this.item.dateStart, 'MMMM YYYY г.') : '';
                const isNow = this.item.isNow;
                let end = '';
                if (isNow) {
                    end = 'по настоящее время';
                } else {
                    end = this.item.dateEnd ? getFormattedDate(this.item.dateEnd, 'MMMM YYYY г.') : '';
                }

                return `${ start } ${ isNow ? end : `- ${ end }`}`;
            }
            return '';
        },

        educationPlaceValue() {
            if (this.item && (this.specialStudyPlace && this.item.educationPlace) ||
                (!this.specialStudyPlace && this.place)) {
                return this.specialStudyPlace ? this.item.educationPlace : this.place.field_value;
            }
            return '';
        },

        academicDegreeValue() {
            if (this.item && this.item.foreignDegreeId && this.dictionaryByType('academic_degree')) {
                const degreeList = this.dictionaryByType('academic_degree') || [];
                const degree = degreeList.find(el => el.id == this.item.foreignDegreeId);
                return degree && degree.field_value ? degree.field_value.toLowerCase() : '';
            }
            return '';
        },
    },

    watch: {
        item: {
            immediate: true,
            handler: function(value) {
                if (value.foreignSpecialtyId) {
                    this.loadSpecialtyHandler(value.foreignSpecialtyId);
                }

                if (value.foreignPlaceId) {
                    this.loadForeignPlaceHandler(value.foreignPlaceId);
                }

                if (value.foreignEducationFormId) {
                    this.loadForeignEducationFormHandler(value.foreignEducationFormId);
                }

                if (value.foreignOksoId) {
                    this.loadForeignOksoHandler(value.foreignOksoId);
                }
            },
        },
    },

    methods: {
        ...mapActions(actions),

        getLowerCase(value) {
            return value ? value.toLowerCase() : '';
        },

        async loadSpecialtyHandler(id) {
            this.specialty = await this.getDictionaryItemById(id);
        },

        async loadForeignPlaceHandler(id) {
            this.place = await this.getDictionaryItemById(id);
        },

        async loadForeignEducationFormHandler(id) {
            this.educationForm = await this.getDictionaryItemById(id);
        },

        async loadForeignOksoHandler(id) {
            this.okso = await this.getDictionaryItemById(id);
        },
    },
};
</script>

<style scoped lang="scss">
@media (max-width: 449px) {
    .participant-full-profile .row-value {
        display: inline-block;
        word-break: break-word;
        margin: 0 0 0 0;
    }
}
</style>